module.exports = __webpack_public_path__ + "img/TADA.08c26eff.png";